import React, { PureComponent } from 'react';

export default class MetricsHeader extends PureComponent {
  static propTypes = {
    // TODO
  }

  render() {
    return (
      <div className="row table-row" style={{ fontWeight: 'bold', marginTop: '20px' }}>
        <div className="col-3">Component</div>
        <div className="col-2">CSS size</div>
        <div className="col-2">CSS specificity (avg)</div>
        <div className="col-2">JS size</div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/MetricsPage/MetricsHeader.jsx